import classes from "./FileDropZone.module.css";
import Dropzone from "react-dropzone";
import { useCurrentDataContext } from "../../../contexts/CurrentDataContext";
import { useTranslation } from "react-i18next";
import { GrDocumentPdf } from "react-icons/gr";
import { BsFillXCircleFill } from "react-icons/bs";
import { Record } from "../../../contexts/interfaces";
import openFile from "../../../scripts/openFile";
import { encode } from "base64-arraybuffer";
import { toast } from "react-toastify";

interface Props {
  fileType: string;
}

const FileDropZone = ({ fileType }: Props) => {
  const { currentData, setCurrentData } = useCurrentDataContext();

  // Set translation
  const { t } = useTranslation();

  const removeRecord = (recordToBeRemoved: Record) => {
    // Find index of record from currentData records
    const index = currentData?.records?.findIndex(
      (item) => item.id === recordToBeRemoved.id
    );

    if (currentData?.records && index !== -1) {
      let updatedRecords = currentData.records;
      // Remove index of recordToBeRemoved from updatedRecords
      updatedRecords.splice(Number(index), 1);

      // Set updatedRecords as new records of currentData
      setCurrentData({
        ...currentData,
        records: updatedRecords,
      });
    }
  };
  // TODO: Loading effects, size of file shown etc.

  return (
    <>
      <Dropzone
        accept={["application/pdf", "image/*"]}
        maxSize={6000000}
        onDropAccepted={(acceptedFiles) => {
          const reader = new FileReader();
          reader.onabort = () => console.log("file reading was aborted");
          reader.onerror = () => console.log("file reading has failed");
          reader.onload = () => {
            // Take ArrayBuffer into result
            const result = reader.result;

            if (result) {
              // -> Base64
              const base64Str = `data:${acceptedFiles[0].type};base64,${encode(
                result as ArrayBuffer
              )}`;

              // Create new record, add base64 string to file
              const newRecord = {
                id:
                  +Date.now().toString().slice(-8) +
                  Math.floor(Math.random() * 10),
                file: base64Str,
                title: acceptedFiles[0].name,
                type: fileType,
              };

              currentData &&
                setCurrentData({
                  ...currentData,
                  records: currentData?.records
                    ? [...currentData.records, newRecord]
                    : [newRecord],
                });
            }
          };
          reader.readAsArrayBuffer(acceptedFiles[0]);
        }}
        onDropRejected={() => {
          toast(`${t("message.fileTooBig")}`, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <div
              className={classes.recordsContainer}
              style={
                currentData?.records && currentData?.records?.length > 0
                  ? { display: "flex" }
                  : { display: "none" }
              }
            >
              {currentData?.records &&
                currentData?.records.map((record, i) => {
                  //previewFiles.map((record, i) => {
                  if (record.type === fileType) {
                    return (
                      <div key={i} className={classes.recordItem}>
                        <div
                          onClick={() => openFile(record.file)}
                          className={classes.recordIconNameContainer}
                        >
                          <GrDocumentPdf className={classes.fileIcon} />
                          {record.title}
                        </div>
                        <div className={classes.recordActionContainer}>
                          <BsFillXCircleFill
                            className={classes.removeCircle}
                            onClick={() => removeRecord(record)}
                          />
                          {/*
                                                        <FaCheckCircle
                                                        className={classes.checkCircle}
                                                    />
                                        */}
                        </div>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
            </div>
            <div
              {...getRootProps({
                className: `dropzone ${classes.dropzone}`,
              })}
              style={
                !currentData?.records || currentData?.records?.length === 0
                  ? { borderTop: "3px dashed #eeeeee" }
                  : { borderTop: "none" }
              }
            >
              <input {...getInputProps()} />

              <div>
                {`${t("fileDropZone.dragAndDropOr")}`}
                <span style={{ color: "#ED1B24" }}>
                  {`${t("fileDropZone.browseFiles")}`}
                </span>
              </div>
            </div>
          </section>
        )}
      </Dropzone>
    </>
  );
};

export default FileDropZone;
